import React from 'react';
import { Bell } from './bell';
import { CallingAvatar, CallingAvatarHighlight } from './calling-avatar';
import {
	ChevronDown,
	ChevronLight,
	ChevronRounded,
	ChevronUp,
	QuestionChevron,
} from './chevron';
import { Cross } from './cross';
import {
	FaqBubble,
	FaqBubbleHighlight,
	FaqBubbleHighlightOutline,
} from './faq-bubble';
import { Info } from './info';
import { Phone, PhoneHighLight } from './phone';
import { Tick } from './tick';
import { Warning } from './warning';
import { HandCard } from './hand-card';
import { Call } from './call';
import { FaceBook } from './fb';
import { YouTube } from './yb';
import { InstaGram } from './ig';
import { FacebookLogo } from './facebook-logo';
import { TwitterLogo } from './twitter-logo';
import { YoutubeLogo } from './youtube-logo';
import { InstagramLogo } from './instagram-logo';
import { Close } from './close';

const Svg: { [key: string]: React.FC } = {
	phone: Phone,
	'phone-highLight': PhoneHighLight,
	'calling-avatar': CallingAvatar,
	'calling-avatar-highLight': CallingAvatarHighlight,
	cross: Cross,
	chevronDown: ChevronDown,
	chevronUp: ChevronUp,
	'chevron-rounded': ChevronRounded,
	'cheveron-question': QuestionChevron,
	'cheveron-light': ChevronLight,
	info: Info,
	warning: Warning,
	'faq-bubble': FaqBubble,
	'faq-bubble-highlight': FaqBubbleHighlight,
	'faq-bubble-highlight-outline': FaqBubbleHighlightOutline,
	bell: Bell,
	tick: Tick,
	'hand-card': HandCard,
	call: Call,
	fb: FaceBook,
	yb: YouTube,
	ig: InstaGram,
	facebook: FacebookLogo,
	twitter: TwitterLogo,
	youtube: YoutubeLogo,
	instagram: InstagramLogo,
	close: Close,
};

interface SvgIconProps {
	svgName: string;
	color?: string;
	hover?: string;
}

export const SvgIcon: React.FC<SvgIconProps> = ({ svgName }) => {
	return (
		<>
			{svgName === 'phone' && <Phone />}
			{svgName === 'phone-highLight' && <PhoneHighLight />}
			{svgName === 'calling-avatar' && <CallingAvatar />}
			{svgName === 'calling-avatar-highLight' && <CallingAvatarHighlight />}
			{svgName === 'cross' && <Cross />}
			{svgName === 'chevronDown' && <ChevronDown />}
			{svgName === 'chevronUp' && <ChevronUp />}
			{svgName === 'chevron-rounded' && <ChevronRounded />}
			{svgName === 'cheveron-question' && <QuestionChevron />}
			{svgName === 'cheveron-light' && <ChevronLight />}
			{svgName === 'info' && <Info />}
			{svgName === 'warning' && <Warning />}
			{svgName === 'faq-bubble' && <FaqBubble />}
			{svgName === 'faq-bubble-highlight' && <FaqBubbleHighlight />}
			{svgName === 'faq-bubble-highlight-outline' && (
				<FaqBubbleHighlightOutline />
			)}
			{svgName === 'bell' && <Bell />}
			{svgName === 'tick' && <Tick />}
			{svgName === 'hand-card' && <HandCard />}
			{svgName === 'call' && <Call />}
			{svgName === 'fb' && <FaceBook />}
			{svgName === 'yb' && <YouTube />}
			{svgName === 'ig' && <InstaGram />}
			{svgName === 'facebook' && <FacebookLogo />}
			{svgName === 'twitter' && <TwitterLogo />}
			{svgName === 'youtube' && <YoutubeLogo />}
			{svgName === 'instagram' && <InstagramLogo />}
			{svgName === 'close' && <Close />}
		</>
	);
};

export default Svg;
